/**
 * Ros App environment configuration.
 *
 * Local dev: uses defaults (localhost:8787 for reachy-cf).
 * Deployed: overwritten by the deploy script at build time.
 */
export const config = {
  // In dev: empty string = relative paths → Vite proxy handles routing to reachy-cf (no CORS)
  // In prod: full URL to the deployed reachy-cf worker
  API_CF_URL: import.meta.env.VITE_API_CF_URL || '',
  // Where the MCP App single-file bundle is served. Live panels get this from the backend SSE
  // event; the FE only needs it for the session-resume path. Default prod, override locally.
  MCP_APP_URL: import.meta.env.VITE_MCP_APP_URL || 'https://reachy-mcp-app.pages.dev',
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT || 'development',
  VERSION: import.meta.env.VITE_VERSION || 'dev',
  BUILD_DATE: import.meta.env.VITE_BUILD_DATE || new Date().toISOString(),
  // Studio web app — local webpack dev server runs on :3001 (packages/web)
  STUDIO_URL: import.meta.env.VITE_STUDIO_URL
    || (import.meta.env.DEV ? 'http://localhost:3001' : 'https://app.r3studio.us1.rivaltech.io'),
}

/** Known source apps that link to Ros — return URLs are config-based, not from URL params */
export const KNOWN_SOURCES: Record<string, { label: string; url: string }> = {
  studio: { label: 'Studio', url: config.STUDIO_URL },
  rival: { label: 'Rival', url: 'https://app.rivaltech.com' },
}
